<div class="balance-chart-runner">
    <div class="balance-chart-runner__flagpole"></div>
    <div class="balance-chart-runner__flag">
        <ng-content></ng-content>
    </div>
</div>
